import { useCountdown } from "../../../utils/useCountdown";
import { useEventData } from "../DataProvider";
import { formatSecondsToTime } from "../../../utils/helper-funcs";
import { RacingBanner } from "../Banner";

export function Header() {
  const { eventData } = useEventData();
  const time = useCountdown({ startTime: eventData.startTime });
  return (
    <div className="flex items-start justify-between w-full">
      <div className="h-12 md:h-16 lg:h-[102px]">
        <RacingBanner />
      </div>
      <div className="flex flex-col items-end">
        <span className="text-xs font-normal lg:text-2xl">
          Next race off in
        </span>

        <span className="text-2xl md:text-[40px] leading-10 italic font-extrabold lg:text-3xl">
          {formatSecondsToTime(time)}
        </span>
      </div>
    </div>
  );
}
